<template>
  <div
    id="modalFindDistributor"
    class="modal fade"
  >
    <div
      class="modal-dialog modal-dialog-vertical-center modal-md"
      role="document"
    >
      <div class="modal-content bd-0 tx-14 overflow-y-auto">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("offer.选择要报价的经销商")}}</h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-x-25 pd-y-5">
          <p>{{$t("offer.选择您要报价的供应商")}}:</p>
          <ul class="select-name">
            <li v-for="item in items" :key="item.id">
              <label class="ckbox">
                <input type="checkbox">
                <span>{{item.name}}</span>
              </label>
            </li>
          </ul>
          <div>
            <pagination v-if="items.length>0" :cur="page" :all="totalPage" :size="7" @page="gotoPage"></pagination>
          </div>
        </div>
        <div class="modal-footer">
          <div>

            <button
              type="button"
              class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold"
            >{{$t("offer.选择可供货商品")}}</button>
            <button
              type="button"
              class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold"
              data-dismiss="modal"
            >{{$t("offer.取消")}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { innerPagination } from "@components/pagination.js"; //分页
export default {
  props: ["open"],
  data() {
    return {
      loading: true,
      items: [],
      page: 1,
      rowsPerPage: 20,
      totalPage: 0,
    };
  },
  components: {
    Pagination: innerPagination
  },
  methods: {
    gotoPage(page){
      this.page = page;
      this.getDistributor();
    },
    getDistributor() {
      this.loading = true;
      $.api_call("api.Distributor.findBySupplier", {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
      }, r => {
        if (r.ErrorCode == "9999") {
          console.log(r);
          this.loading = false;
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    }
  },
  watch: {
    open: function() {
      this.getDistributor();
    }
  }
};
</script>

<style scoped>
.select-name{
  margin: 0 0 15px 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
}
.select-name li{
  width: 50%;
}
</style>


